import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Global } from "recharts";
import { Root } from "./app/containers/Root";
import "./app/i18n";
import "../node_modules/react-quill-new/dist/quill.snow.css";
import "../node_modules/react-quill-new/dist/quill.bubble.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import "antd/dist/reset.css";
import "./app/styles/global.scss";

Global.devToolsEnabled = false;

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
